import { h, ComponentChild } from 'preact'
import tracker from '../../components/tracker/publish'
import CurrentPageContext from '../../server-middleware/pageContext'

const eventTracker = (_: unknown, title: string, url: string, type: string) => {
  if (!['parent category', 'category'].includes(type)) {
    return
  }

  tracker.trackEvent('userevent', {
    type: 'Category Clicked',
    category_title: title,
    category_url: url,
    category_type: type,
    click_source: 'breadcrumb'
  })
}

interface TitleWrapperParams {
  url: string | null
  title: string
  type: string
  children: ComponentChild
}

const TitleWrapper = ({ url, title, type, children }: TitleWrapperParams) => {
  if (url) {
    return <a class='breadcrumb-item-link' href={url} onClick={(e) => eventTracker(e, title, url, type)}>{children}</a>
  } else {
    return <span class='current'>{children}</span>
  }
}

const types = ['homepage', 'parent category', 'category']
const qaClasses = [
  'qa-breadcrumb-community',
  'qa-breadcrumb-category',
  'qa-breadcrumb-forum',
  'qa-breadcrumb-topic'
]

interface Props {
  breadcrumbData?: Array<{
    title: string
    url: string
  }>
}

const Breadcrumb = ({ breadcrumbData }: Props) => {
  return (
    <CurrentPageContext.Consumer>
      {pageContext => {
        const breadcrumbs = breadcrumbData || pageContext.breadcrumbs
        if (!breadcrumbs || !breadcrumbs.length) return null

        return (
          <div class='sitewidth breadcrumb-container'>
            <div class='col main-navigation--breadcrumb-wrapper widget--breadcrumb'>
              <ul className='breadcrumb'>
                {breadcrumbs.map((data, index) => <li key={index} className={`breadcrumb-item ${qaClasses[index]}`}>
                  <TitleWrapper url={breadcrumbs.length > index + 1 ? data.url : null} title={data.title} type={types[index]}>
                    <i className='icon icon--caret-left is-visible-S' />
                    {data.title}
                  </TitleWrapper>
                  <i className='icon icon--caret-right' />
                </li>)}
              </ul>
            </div>
          </div>
        )
      }}
    </CurrentPageContext.Consumer>
  )
}

export { TitleWrapper }
export default Breadcrumb
